import { MarketingClientConstants } from "./constants/marketing-client-constants";
import { PlanBEventType, PlanBMonitorConstants } from "./constants/plan-b-monitor-constants";
import { Utils } from "./utils/utils";
export class PlanBMonitor {
    setGUID(guid) {
        this.guid = guid;
    }
    sendPlanBEvent(templateId) {
        return this.send(templateId, PlanBEventType.PLAN_B);
    }
    sendTimeoutEvent(templateIds) {
        return this.send(this.joinTemplateIds(templateIds), PlanBEventType.TIMEOUT);
    }
    sendHttpErrorEvent(templateIds, status) {
        const message = `${PlanBMonitorConstants.httpErrorMessagePrefix}${status !== null && status !== void 0 ? status : 0}`;
        return this.send(this.joinTemplateIds(templateIds), PlanBEventType.HTTP_ERROR, message);
    }
    joinTemplateIds(templateIds) {
        if (!templateIds.length) {
            return PlanBMonitorConstants.emptyPlanBTemplateId;
        }
        return templateIds.join(PlanBMonitorConstants.templateIdSeparator);
    }
    send(templateId, eventType, message) {
        if (typeof navigator === "undefined" || typeof navigator.sendBeacon !== "function") {
            return false;
        }
        const event = this.prepareEvent(templateId, eventType, message);
        if (!Utils.stringNotEmpty(event.templateId) || !Utils.stringNotEmpty(event.url)) {
            return false;
        }
        try {
            const payload = new Blob([JSON.stringify(event)], { type: PlanBMonitorConstants.contentType });
            return navigator.sendBeacon(PlanBMonitorConstants.eventsPath, payload);
        }
        catch (error) {
            console.warn("Could not send plan B event", error);
            return false;
        }
    }
    prepareEvent(templateId, eventType, message) {
        const event = {
            source: this.getSource(),
            url: window.location.href,
            templateId,
            eventType,
            timestamp: Date.now()
        };
        if (Utils.stringNotEmpty(this.guid) && this.guid !== MarketingClientConstants.noguid) {
            event.guid = this.guid;
        }
        if (Utils.stringNotEmpty(message)) {
            event.message = message;
        }
        return event;
    }
    getSource() {
        const dmParameters = Utils.getDMParams();
        if (Utils.isNullOrUndefined(dmParameters)) {
            return "";
        }
        const source = dmParameters[PlanBMonitorConstants.sourceParam];
        return Utils.stringNotEmpty(source) ? source : "";
    }
}
